module.exports = __webpack_public_path__ + "img/管理-2.374bb08c.jpg";